import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/BrandMark";
import ErrorBoundary from "@/components/ErrorBoundary";
import { ThemeToggle } from "@/components/ThemeToggle";

export default function PublicShell({ children }) {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-white flex flex-col">
      <header className="border-b border-[var(--border)] sticky top-0 z-30 bg-[var(--bg)]/90 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="public-logo" className="flex items-center"><Wordmark /></Link>
          <nav className="flex items-center gap-5 text-sm">
            <Link to="/players" className="text-[var(--text-2)] hover:text-white hidden sm:block" data-testid="public-nav-values">Player Values</Link>
            <Link to="/blog" className="text-[var(--text-2)] hover:text-white hidden sm:block" data-testid="public-nav-blog">The Wire</Link>
            <Link to="/pricing" className="text-[var(--text-2)] hover:text-white hidden sm:block">Pricing</Link>
            <ThemeToggle />
            <Link to="/login" className="btn-primary text-sm px-4 py-2" data-testid="public-nav-cta">Get Started Free</Link>
          </nav>
        </div>
      </header>
      <main className="flex-1 max-w-7xl mx-auto px-6 py-8 w-full"><ErrorBoundary>{children}</ErrorBoundary></main>
      <footer className="border-t border-[var(--border)] mt-12">
        <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--text-3)]">
          <span>© {new Date().getFullYear()} Dynasty Metrics — proprietary DME dynasty valuations.</span>
          <div className="flex items-center gap-4">
            <Link to="/players" className="hover:text-white">All Players</Link>
            <Link to="/blog" className="hover:text-white">The Wire</Link>
            <Link to="/pricing" className="hover:text-white">Pricing</Link>
            <Link to="/login" className="hover:text-[var(--accent)]">Sign in</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
